<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="half"><span class="bold">Pastels <span class="hf">for the</span> <span class="hfa">Absolute Beginner</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Half.vue?50e13d82